import React from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { SubmitButton} from "../../../components/formik/button/SubmitButton.jsx";
import { TextBoxInput } from '../../../components/formik/inputs/TextBoxInput.jsx';
import { PasswordInput } from '../../../components/formik/inputs/PasswordInput.jsx';
import {Link, useNavigate} from 'react-router';
import { AppPath } from '../../../Router/AppRouter.jsx';
import {useAuth} from "../../../context/AuthContext.jsx";
import {GridContainerFlex} from "../../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";
import {Card} from "../../../components/composite/Card/Card.jsx";

const LoginForm = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (values) => {
        await login(values?.username, values?.password);
        const redirectUrl = new URLSearchParams(window.location.search).get('redirectUrl');
        navigate(redirectUrl ? `/${redirectUrl.replace(/^\//, '')}` : AppPath.home);
    };

    // temp willm@dairyeng.com

    const initialValues = { username: '', password: '' };
    const validationSchema = Yup.object({
        username: Yup.string().email('Use your email address').required('Required'),
        password: Yup.string().required('Required'),
    });

    return (
        <Card title={"Login"}>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        setSubmitting(true)
                        await handleLogin(values);
                    } catch (e) {
                        console.error(e);
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                <Form>
                    <GridContainerFlex
                        flexDirection={"column"}
                        alignItems={"start"}
                        gap={"20px"}
                    >
                        <GridItemFlex xs={12}>
                            <TextBoxInput
                                name="username"
                                label="Email Address"
                                placeholder="you@example.com"
                            />
                        </GridItemFlex>

                        <GridItemFlex xs={12}>
                            <PasswordInput
                                name="password"
                                label="Password"
                                autoComplete="current-password"
                            />
                        </GridItemFlex>

                        <GridItemFlex>
                            <SubmitButton >
                                Log In
                            </SubmitButton>
                        </GridItemFlex>
                        <GridItemFlex>
                            <Link to={AppPath.requestPasswordReset}>Forgot password?</Link>
                        </GridItemFlex>
                    </GridContainerFlex>
                </Form>
            </Formik>
        </Card>

    );
};

export default LoginForm;
